import React from "react";

import classnames from "classnames";
import "./SelectAddressCard.css";

interface SelectAddressCardProps {
  address: {
    address1?: string;
    address2?: string;
    city?: string;
    postalCode?: string;
    state?: string;
  };
  isSelected?: boolean;
  isInvalid?: boolean;
  onSelect?: React.MouseEventHandler<HTMLDivElement>;
  userName?: string;
}

const SelectAddressCard = ({
  address,
  isSelected,
  isInvalid,
  onSelect,
  userName,
}: SelectAddressCardProps) => {
  const { address1, address2, state, city, postalCode } = address;

  const cardClass = classnames("select-address-card", {
    selected: isSelected,
    shadow: !isInvalid,
    invalid: isInvalid,
  });

  if (isInvalid) {
    return (
      <div className={cardClass}>
        <p>
          USPS could not your validate address. Please check that the address
          you entered is valid.
        </p>
      </div>
    );
  } else {
    return (
      <div className={cardClass} onClick={onSelect}>
        <p>{userName}</p>
        <p>{address1}</p>
        {address2 && <p>{address2}</p>}
        <p>
          {city}, {state} {postalCode}
        </p>
      </div>
    );
  }
};

export default SelectAddressCard;
